// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(value) {
  if (value) {
    return "DateTime";
  } else {
    return "Mins";
  }
}

function toType(value) {
  switch (value) {
    case "DateTime" :
        return /* DateTime */1;
    case "Mins" :
        return /* Mins */0;
    default:
      return ErrorUtils$Catalyst.raiseError("AdjustFareFormRoot.res", "Invalid duration selector value", value);
  }
}

var DurationSelector = {
  toString: toString,
  toType: toType
};

function resetFormState(current_state) {
  return {
          form_duration_selector: /* Mins */0,
          current_fare_details: current_state.current_fare_details,
          incident_charges_types: current_state.incident_charges_types,
          new_fare_datails: current_state.current_fare_details,
          snackbar_message: undefined,
          is_submit_button_enabled: false,
          is_preview_fare_button_enabled: false,
          reset_form: false
        };
}

function reducer(state, action) {
  if (typeof action === "number") {
    return {
            form_duration_selector: state.form_duration_selector,
            current_fare_details: state.current_fare_details,
            incident_charges_types: state.incident_charges_types,
            new_fare_datails: state.new_fare_datails,
            snackbar_message: undefined,
            is_submit_button_enabled: state.is_submit_button_enabled,
            is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
            reset_form: state.reset_form
          };
  }
  switch (action.TAG | 0) {
    case /* UpdateFormDurationSelector */0 :
        return {
                form_duration_selector: action.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* SetCurrentFare */1 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: action.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* UpdateNewFareDetails */2 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: action.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* OpenSnackbar */3 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: action.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* SetIncidentalChargesTypes */4 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: action.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* UpdateSubmitButtonStatus */5 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: action.is_submit_button_enabled,
                is_preview_fare_button_enabled: state.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* UpdatePreviewButtonStatus */6 :
        return {
                form_duration_selector: state.form_duration_selector,
                current_fare_details: state.current_fare_details,
                incident_charges_types: state.incident_charges_types,
                new_fare_datails: state.new_fare_datails,
                snackbar_message: state.snackbar_message,
                is_submit_button_enabled: state.is_submit_button_enabled,
                is_preview_fare_button_enabled: action.is_preview_fare_button_enabled,
                reset_form: state.reset_form
              };
    case /* ResetChanges */7 :
        var init = resetFormState(state);
        return {
                form_duration_selector: init.form_duration_selector,
                current_fare_details: init.current_fare_details,
                incident_charges_types: init.incident_charges_types,
                new_fare_datails: init.new_fare_datails,
                snackbar_message: init.snackbar_message,
                is_submit_button_enabled: init.is_submit_button_enabled,
                is_preview_fare_button_enabled: init.is_preview_fare_button_enabled,
                reset_form: action.reset_form
              };
    
  }
}

var intitial_state = {
  form_duration_selector: /* Mins */0,
  current_fare_details: /* Init */0,
  incident_charges_types: /* Init */0,
  new_fare_datails: /* Init */0,
  snackbar_message: undefined,
  is_submit_button_enabled: false,
  is_preview_fare_button_enabled: false,
  reset_form: false
};

export {
  DurationSelector ,
  intitial_state ,
  resetFormState ,
  reducer ,
  
}
/* No side effect */
